let captchaResponse;
let widgetId;
let requiredCaptcha = false;

const Recaptcha = {

    captchaRetries: CWCONFIG.captchaConfig.captchaRetries,
    captchaKey: CWCONFIG.captchaConfig.captchaKey,

    /**
     * Initializer for the recaptcha service - loads a <script> tag in the dom
     */
    init() {

        // disabled cus since angular-recaptcha@4.0
        // the script loading is done in the library

        // const SCRIPT_ID = 'captchaSrc';

        // if (window.document.getElementById(SCRIPT_ID)) {

        //     return;

        // }

        // const captchaScript = window.document.createElement('script');
        // captchaScript.type = 'text/javascript';
        // captchaScript.id = SCRIPT_ID;
        // captchaScript.async = true;
        // captchaScript.defer = true;
        // captchaScript.src = CWCONFIG.captchaConfig.captchaUrl + CWCONFIG.language;
        // const jsScripts = window.document.getElementsByTagName('script')[0];
        // jsScripts.parentNode.insertBefore(captchaScript, jsScripts);

        // this.disableCaptcha();

    },

    setWidgetId(id) {

        widgetId = id;

    },

    getWidgetId() {

        return widgetId;

    },

    execute() {

        if (window.grecaptcha) {

            window.grecaptcha.execute(widgetId);

        }

    },

    reset() {

        if (window.grecaptcha) {

            window.grecaptcha.reset(widgetId);

        }

    },


    setCaptchaResponse(response) {

        captchaResponse = response;
        this.disableCaptcha();
        this.reset(widgetId);

    },

    getCaptchaResponse() {

        return captchaResponse || false;

    },

    enableCaptcha() {

        requiredCaptcha = true;

    },

    disableCaptcha() {

        requiredCaptcha = false;

    },

    isCaptchaRequired() {

        return requiredCaptcha && window.grecaptcha;

    },

};

export default Recaptcha;



// WEBPACK FOOTER //
// ./scripts/services/recaptcha.js